module.exports = __webpack_public_path__ + "media/images/area/area_shikokuM400-2ffcfeaa56fdf5e9fe1792f4827b3482.jpg";